import handleError from 'utils/handleError';

const handleErrors = () => (next) => (action) => {
    const result = next(action);

    return result instanceof Promise ? result.catch(handleError) : result;
};

export default handleErrors;
